<template>
  <div class="w-100">
    <h4 class="pb-3 mb-0 border-bottom d-flex">
      {{ $t('marketing.sentEmails') }}
    </h4>

    <p
      v-if="status !== 'SENT'"
      class="text-center pt-4 mb-0">
      {{ $t('marketing.mailingNotSentYet') }}
    </p>
    <template v-else>
      <d-alert
        v-if="loadError"
        show
        theme="warning"
        class="text-center mt-3">
        {{ $t('ui.dataLoadingFailed') }}&hellip;
      </d-alert>
      <d-alert
        v-else-if="!loaded"
        show
        theme="light"
        class="text-center mt-3">
        {{ $t('ui.dataLoading') }}&hellip;
      </d-alert>
      <template v-else>
        <table class="table mt-2 mb-0 full-width">
          <thead class="bg-light">
            <tr>
              <th scope="col" class="border-0 align-middle">{{ $t('ui.emailAddress') }}</th>
              <th scope="col" class="border-0 align-middle text-center">{{ $t('ui.language') }}</th>
              <th scope="col" class="border-0 align-middle text-right">{{ $t('marketing.sentAt') }}</th>
            </tr>
          </thead>
          <tbody v-if="emails.length">
            <tr v-for="(item, index) of emails" :key="'email-' + index">
              <td class="align-middle">{{ item.email }}</td>
              <td class="align-middle text-center">
                {{ getLanguageByID(item.language_id) }}
              </td>
              <td class="align-middle text-right">
                {{ formatDate(item.sent_at) }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="3" class="text-center">{{ $t('marketing.noMessagesToDisplay') }}&hellip;</td>
            </tr>
          </tbody>
        </table>

        <pagination
          v-if="emails.length"
          :meta-data="paginationMetaData"
          :initial-page="currentPage" />
      </template>
    </template>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import ListUtils from '@/utils/ListUtils.js';
import CalendarUtils from '@/utils/CalendarUtils';
import HasPagination from '@/mixins/HasPagination.vue';
import Pagination from '@/components/common/Pagination.vue';

export default {
  name: 'mailing-emails-list',
  mixins: [
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  props: {
    languages: {
      default: () => [],
      type: Array
    },
    status: {
      default: null,
      type: String
    },
    templateId: {
      required: true,
      type: [Number, String]
    }
  },
  data () {
    return {
      emails: [],
      loaded: false,
      loadError: false
    };
  },
  mounted () {
    if (this.status === 'SENT') {
      this.debouncedLoadFilteredData();
    }
  },
  methods: {
    debouncedLoadFilteredData: debounce(function () {
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      if (!this.templateId) {
        return;
      }

      this.loadError = false;

      ListUtils.loadPaginatedItemsData(this, {
        endpoint: '/marketing/mailings/emails/items?template_id=' + this.templateId + '&page=' + this.currentPage,
        method: 'get',
        listField: 'emails'
      });
    },
    getLanguageByID (languageID) {
      let filteredLanguages = this.languages.filter(language => language.id === languageID);

      if (filteredLanguages.length) {
        return filteredLanguages[0].name;
      }

      return '';
    },
    formatDate (date) {
      if (!date) {
        return '-'
      }

      return CalendarUtils.formatDateForPHP(new Date(date));
    },
  }
}
</script>
